/**
 * WhatsApp Links Utility
 * Handles WhatsApp and WhatsApp Business deep links with proper fallback
 */

// Detect if running on mobile device
export const isMobile = () => {
  if (typeof window === 'undefined') return false;
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

// Detect if running on iOS
export const isIOS = () => {
  if (typeof window === 'undefined') return false;
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
};

// Detect if running on Android
export const isAndroid = () => {
  if (typeof window === 'undefined') return false;
  return /Android/i.test(navigator.userAgent);
};

/**
 * Open WhatsApp (regular)
 * Uses universal wa.me link that works everywhere
 */
export const openWhatsApp = (phone, message = '') => {
  const cleanPhone = phone.replace(/[^0-9]/g, '');
  const encodedMessage = encodeURIComponent(message);
  const url = `https://wa.me/${cleanPhone}?text=${encodedMessage}`;
  window.open(url, '_blank');
};

/**
 * Open WhatsApp Business
 * Uses wa.me which automatically opens WhatsApp Business if it's installed
 * and set as default, otherwise opens regular WhatsApp
 * 
 * Note: There's no reliable way to force WhatsApp Business on iOS.
 * The wa.me link will open whichever WhatsApp app the user has.
 */
export const openWhatsAppBusiness = (phone, message = '') => {
  const cleanPhone = phone.replace(/[^0-9]/g, '');
  const encodedMessage = encodeURIComponent(message);
  
  if (isAndroid()) {
    // On Android, try the intent URL which can specifically target WhatsApp Business
    // If WA Business is not installed, it will prompt to install or fail gracefully
    const intentUrl = `intent://send?phone=${cleanPhone}&text=${encodedMessage}#Intent;package=com.whatsapp.w4b;scheme=whatsapp;S.browser_fallback_url=https://wa.me/${cleanPhone}?text=${encodedMessage};end`;
    window.location.href = intentUrl;
  } else {
    // On iOS and other platforms, use wa.me
    // iOS doesn't support app-specific deep links for WhatsApp Business
    // The user's default WhatsApp app will open
    const url = `https://wa.me/${cleanPhone}?text=${encodedMessage}`;
    window.open(url, '_blank');
  }
};

/**
 * Get WhatsApp link for href attribute
 */
export const getWhatsAppLink = (phone, message = '') => {
  const cleanPhone = phone.replace(/[^0-9]/g, '');
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${cleanPhone}?text=${encodedMessage}`;
};

/**
 * Get WhatsApp Business link for href attribute
 * Note: On iOS, this returns the same as regular WhatsApp link
 */
export const getWhatsAppBusinessLink = (phone, message = '') => {
  const cleanPhone = phone.replace(/[^0-9]/g, '');
  const encodedMessage = encodeURIComponent(message);
  // Always use wa.me for href - it's the most compatible
  return `https://wa.me/${cleanPhone}?text=${encodedMessage}`;
};
